import { createStyles, makeStyles, Step, StepConnector, StepLabel, Stepper, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSignup } from "./state/SelfSignup";
import { ESignupStages } from "./types";


const steps = [
    "step1",
    "step2",
    "step3"
]

const Connector = withStyles({
    line: {
        border: 'none',
        minHeight: '0.5rem'
    }
})(StepConnector);

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.background.default,
        },
        text: {
            color: theme.palette.text.secondary,
            fontSize: "1rem"
        },
    }))

export function SignupStepper() {
    const classes = useStyles();
    const { stage } = useSignup();
    const [step, setStep] = useState<number | null>(0);
    const { t } = useTranslation();
    useEffect(() => {
        function activeStep() {
            switch (stage) {
                case ESignupStages.DETAILS:
                    return 0;
                case ESignupStages.VENUE:
                    return 1;
                case ESignupStages.SUBSCRIPTION:
                    return 2;
                default:
                    return null;
            }
        }
        setStep(activeStep());
    }, [stage])

    if (step === null) return null;

    return <div>
        <div className={classes.text}>
            {t('signup.stepper.title')}
        </div>
        <Stepper className={classes.root} activeStep={step} connector={<Connector />} orientation="vertical">
            {steps.map((step) => (
                <Step key={step}>
                    <StepLabel>
                        {t(`signup.stepper.${step}`)}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    </div>

}